import React, { useContext, useState, useEffect } from "react";
import { UserInformationContext, C4FStatusContext } from "../main/App";
import Race from "./Race";
import { Row, Container, Col } from 'react-bootstrap';
import { useLocation } from "react-router-dom";
import { getRegularTeam } from "../common/Helpers";

function RaceWrapper(props) {
    const { userInformation } = useContext(UserInformationContext);
    const { handleBackendRequest } = useContext(C4FStatusContext);
    const [status, setStatus] = useState('loading');
    const [userRole, setUserRole] = useState(null);
    const [teamId, setTeamId] = useState(null);
    const [raceEditionId, setRaceEditionId] = useState(null);
    const location = useLocation();

    function setUserRoleInRaceEdition(raceEditionId) {
        handleBackendRequest('GET', '/raceEdition/' + raceEditionId, null, 
            { context: 'inscription' },
            function (raceEdition) {
                let userRoleToSet = null;
                let userTeams = userInformation.teams.map(ut => ut.id);
                if (raceEdition.teams.some(ret => ['Completed', 'Active', 'Disqualified'].includes(ret.status) && userTeams.includes(ret.team.id))) {
                    setTeamId(raceEdition.teams.find(ret => ['Completed', 'Active', 'Disqualified'].includes(ret.status) && userTeams.includes(ret.team.id)).team.id)
                    userRoleToSet = 'Participant';
                }
                else {
                    if (userInformation.roles.some(role => role === 'Admin'))
                        userRoleToSet = 'Admin';
                    else if (userInformation.roles.some(role => role === 'FairplayCommittee'))
                        userRoleToSet = 'FairplayCommittee';
                    else if (userInformation.roles.some(role => role === 'Mentor'))
                        userRoleToSet = 'Mentor';
                    else
                        userRoleToSet = 'Visitor';
                }
                setUserRole(userRoleToSet);
            });
    }

    useEffect(() => {
        // if race is provided, load the basic details of race, find the right user role
        if (location.state && location.state.raceEditionId) {
            setUserRoleInRaceEdition(location.state.raceEditionId);
            setRaceEditionId(location.state.raceEditionId);
            setStatus('loaded');
        }
        
        // if race button is clicked, try to find team's latest race
        else {
            handleBackendRequest('GET', '/team/' + getRegularTeam(userInformation).teamName, null, null,
            function (result) {
                if (result.currentRaceEdition) {
                    setUserRoleInRaceEdition(result.currentRaceEdition.id);
                    setRaceEditionId(result.currentRaceEdition.id);
                    setStatus('loaded');
                }
                else
                    setStatus('norace');
            });
        }
    }, []);

    if (status === 'loading')
        return <Container>
            <Row className="m-4">
                <Col className=" text-center">
                    <p>Loading race ...</p>
                </Col>
            </Row>
        </Container>
    else if (status === 'loaded')
        return <Race raceEditionId={raceEditionId} userId={userInformation.userID} teamId={teamId} 
            userName={userInformation.userName} userRole={userRole} />
    else
        return <Container>
            <Row className="m-4">
                <Col className=" text-center">
                    <p>You are currently not playing any race, please register to start to play</p>
                </Col>
            </Row>
        </Container>
    
}

export default RaceWrapper;